import { Menu, Icon } from 'semantic-ui-react';
const HelpPageMenuItem = () => {
  return (
    <Menu.Item as="a" target="_blank" href={window.REACT_APP_HELP_PAGE_URL}>
      <Icon name="help" />
    </Menu.Item>
  );
};

export default HelpPageMenuItem;
